import { render, staticRenderFns } from "./HealthCreate.vue?vue&type=template&id=034714c0&scoped=true&"
import script from "./HealthCreate.vue?vue&type=script&lang=js&"
export * from "./HealthCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034714c0",
  null
  
)

export default component.exports